"use strict";
/**************************
 * ************************
 * ************************
 *
 * COPIED FROM https://github.com/Bond-Sports/NotificationsService
 *
 * + Convenience API added.
 *
 * ************************
 * ************************
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCreateDto = exports.ContentDto = exports.RecipientsDto = exports.SenderDto = void 0;
const notifications_sdk_1 = require("@bondsports/notifications-sdk");
// This file contains DTOs for sending notifications with the SendService.
// Start at the Notification object, below.
// It contains all the other request objects.
class SenderDto {
}
exports.SenderDto = SenderDto;
class RecipientsDto {
}
exports.RecipientsDto = RecipientsDto;
class ContentDto {
}
exports.ContentDto = ContentDto;
class NotificationCreateDto {
    constructor() {
        this.classification = notifications_sdk_1.NotificationClassification.UNKNOWN;
        /**
         *
         */
        /**
         * Send an email notification using a templateKey and dynamic data.
         *
         * (Added for convenience; Not part of NotificationsService object definitions.)
         *
         */
    }
}
exports.NotificationCreateDto = NotificationCreateDto;
//# sourceMappingURL=notification.create.dto.js.map